import React, { useState } from "react"
import { IconButton, Modal } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { makeStyles } from "@material-ui/core/styles"
import PartBrowser from "components/PartBrowser/PartBrowser"
import { useWrapperModals } from "context/wrapperModals/WrapperModalsContext"
import { IS_NEW_PART, NEW_STRUCTURE, WRAPPER_MODALS } from "context/types"

function getModalStyle() {
  const top = 50
  const left = 50

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  }
}

const useStyles = makeStyles(theme => ({
  paper: {
    position: "absolute",
    width: "100%",
    height: "100vh",
    boxShadow: theme.shadows[5],
    borderRadius: 6,
    overflowY: "hidden",
    overflowX: "hidden",
    backgroundColor: "#F6F7FB",
    zIndex: 1302,
  },
}))

const PartBrowserModal = () => {
  const classes = useStyles()
  const [modalStyle] = useState(getModalStyle)
  const { partBrowser, newModalPart } = useWrapperModals()
  const [busy, setBusy] = useState(false)

  const closeBrowser = () => {
    partBrowser.setProperty({
      open: false,
      from: WRAPPER_MODALS,
      chapterId: null,
      partida: null,
    })
  }

  const handleClose = () => {
    if (busy) return
    closeBrowser()
  }

  // Mismo relevo que hace ModalImportPartFromBc3Link: se cierra este modal y se
  // abre NewModalPartida con la partida precargada. El `from: IS_NEW_PART` no
  // es cosmético — NewModalPartida lo usa para decidir crear (false) en vez de
  // editar (true), así que cambiarlo abriría el modal en modo edición.
  const handleAddPart = partida => {
    const chapterId = partBrowser.chapterId
    closeBrowser()
    newModalPart.setProperty({
      open: true,
      from: IS_NEW_PART,
      chapterId,
      partida,
      bancoDePrecios: "",
      srcPage: NEW_STRUCTURE,
    })
  }

  return (
    <Modal open={partBrowser.open} onClose={handleClose}>
      <div style={modalStyle} className={classes.paper}>
        <IconButton
          onClick={handleClose}
          disabled={busy}
          sx={{
            position: "absolute",
            top: 8,
            right: 12,
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
        <PartBrowser
          mode="modal"
          onAddPart={handleAddPart}
          onBusyChange={setBusy}
        />
      </div>
    </Modal>
  )
}

export default PartBrowserModal
